<template>
        <tr style="height: 110px;" v-if="width > 767">
            <th>
                <div class="d-flex justify-content-between position-relative">
                    <span class="mt-1">{{ columnName }}</span>
                </div>
            </th>
            <td>
                <input class="rounded border" size="110" v-model="memberNumber" />
            </td>
        </tr>
    <div v-else>
        <div class="d-flex justify-content-between position-relative p-3 rounded" style="background: #FAF4EC; ">
            <span class="mt-1 sp-input-column">{{ columnName }}</span>
        </div>
        <input class="rounded border sp-input" v-model="memberNumber" />
    </div>
</template>

<script>
export default ({
    props: {
        columnName: String,
    },
    data() {
        return {
            width: this.$store.state.width,
        }
    },
    computed: {
        memberNumber: {
            get() {
                return this.$store.state.memberNumber
            },
            set(v) {
                this.$store.commit('updateMemberNumber', v)
            }
        },
        checkName() {
            let isPassCheck = true
            if (this.name.length === 0) {
                isPassCheck = false
            }

            return isPassCheck
        },
    },
    mounted: function () {
        window.addEventListener('resize', this.headlineResize)
    },
    methods: {
        headlineResize() {
            this.width = window.outerWidth;
        },
    },
})
</script>
